<template>
  <div class="card-modal" :class="templateClass" @dragover.prevent>
    <div class="card-modal__wrapper">
      <!-- top -->
      <slot name="card-modal-top" />
      <!-- header -->
      <div class="card-modal__header">
        <slot name="card-modal-header" />
      </div>
      <!-- body -->
      <div class="card-modal__body">
        <!-- main content -->
        <div class="card-modal__content">
          <slot name="card-modal-content" />
        </div>
        <!-- sidebar -->
        <slot name="card-modal-sidebar" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardModalLayout',

  props: {
    template: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    templateClass() {
      return this.template && 'template'
    },
  },
}
</script>

<style scoped>
.card-modal {
  position: relative;
  border-radius: 8px;
}

.card-modal__wrapper {
  border-radius: 8px;
  background: var(--c-secondary-300);
}

.card-modal__header {
  display: grid;
  align-items: center;
  padding: 21px 30px 26px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  background-color: #fff;
}

.card-modal__body {
  display: grid;
  grid-template-columns: 75% 25%;
}

.card-modal__content {
  padding: 20px;
  background: var(--c-secondary-300);
  overflow: hidden;
}

/* Responsive ---------- */
@media (min-width: 681px) {
  .card-modal__content {
    border-bottom-left-radius: 8px;
  }
}

@media (max-width: 680px) {
  .card-modal__wrapper {
    padding-bottom: 40px;
  }

  .card-modal__header {
    grid-template-columns: auto 1fr;
    padding: 10px 30px 10px;
  }

  .card-modal__body {
    grid-template-columns: 1fr;
  }

  .card-modal__content {
    padding-bottom: 40px;
  }
}
</style>
